import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { authKeys } from '@/shared/lib/query/queryKeys';

import type { UserProfile } from '@/entities/auth';

import { fetchCurrentUser } from '@/features/auth/api';

export const useCurrentUser = (enabled: boolean = true): UseQueryResult<UserProfile, Error> => {
  return useQuery({
    queryKey: authKeys.currentUser(),
    queryFn: fetchCurrentUser,
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
};
